/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiSupportEmailTemplateAddPost } from '../fn/email-template/api-support-email-template-add-post';
import { ApiSupportEmailTemplateAddPost$Params } from '../fn/email-template/api-support-email-template-add-post';
import { apiSupportEmailTemplateEditPost } from '../fn/email-template/api-support-email-template-edit-post';
import { ApiSupportEmailTemplateEditPost$Params } from '../fn/email-template/api-support-email-template-edit-post';
import { apiSupportEmailTemplateGetAllGet } from '../fn/email-template/api-support-email-template-get-all-get';
import { ApiSupportEmailTemplateGetAllGet$Params } from '../fn/email-template/api-support-email-template-get-all-get';
import { EmailTemplate } from '../models/email-template';
import { EmailTemplateApiRespModel } from '../models/email-template-api-resp-model';

@Injectable({ providedIn: 'root' })
export class EmailTemplateService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiSupportEmailTemplateAddPost()` */
  static readonly ApiSupportEmailTemplateAddPostPath = '/api/Support/EmailTemplate/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSupportEmailTemplateAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiSupportEmailTemplateAddPost$Response(params?: ApiSupportEmailTemplateAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<EmailTemplateApiRespModel>> {
    return apiSupportEmailTemplateAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSupportEmailTemplateAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiSupportEmailTemplateAddPost(params?: ApiSupportEmailTemplateAddPost$Params, context?: HttpContext): Observable<EmailTemplateApiRespModel> {
    return this.apiSupportEmailTemplateAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<EmailTemplateApiRespModel>): EmailTemplateApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiSupportEmailTemplateEditPost()` */
  static readonly ApiSupportEmailTemplateEditPostPath = '/api/Support/EmailTemplate/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSupportEmailTemplateEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiSupportEmailTemplateEditPost$Response(params?: ApiSupportEmailTemplateEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<EmailTemplateApiRespModel>> {
    return apiSupportEmailTemplateEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSupportEmailTemplateEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiSupportEmailTemplateEditPost(params?: ApiSupportEmailTemplateEditPost$Params, context?: HttpContext): Observable<EmailTemplateApiRespModel> {
    return this.apiSupportEmailTemplateEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<EmailTemplateApiRespModel>): EmailTemplateApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiSupportEmailTemplateGetAllGet()` */
  static readonly ApiSupportEmailTemplateGetAllGetPath = '/api/Support/EmailTemplate/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSupportEmailTemplateGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSupportEmailTemplateGetAllGet$Response(params?: ApiSupportEmailTemplateGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmailTemplate>>> {
    return apiSupportEmailTemplateGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSupportEmailTemplateGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSupportEmailTemplateGetAllGet(params?: ApiSupportEmailTemplateGetAllGet$Params, context?: HttpContext): Observable<Array<EmailTemplate>> {
    return this.apiSupportEmailTemplateGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EmailTemplate>>): Array<EmailTemplate> => r.body)
    );
  }

}
